import "./src/styles/global.css";

// Require for Code Syntax Highlighting
require("prismjs/themes/prism-okaidia.css");

// Type Faces
require("typeface-montserrat");
require("typeface-comfortaa");
require("typeface-poppins");
require("@fontsource/eb-garamond");

// Blog reading faces — Source Serif 4 body (screen-first serif), Fraunces display
require("@fontsource/source-serif-4/400.css");
require("@fontsource/source-serif-4/400-italic.css");
require("@fontsource/source-serif-4/600.css");
require("@fontsource/fraunces/600.css");
require("@fontsource/fraunces/700.css");

// M1K3 section type faces
require("@fontsource/vt323");
require("@fontsource/ibm-plex-mono/300.css");
require("@fontsource/ibm-plex-mono/400.css");
require("@fontsource/ibm-plex-mono/500.css");
